// extracted by mini-css-extract-plugin
export default {"policyPage":"PolicyPage_policyPage__hEltT","contentWrapper":"PolicyPage_contentWrapper__WW+A3","title":"PolicyPage_title__JHBav","content":"PolicyPage_content__MLPoZ"};